/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsAccounts = {
  init: function($section){

    $('.js-recover-password').on('click', function(){
      $('#login').hide();
      $('.heading-wrapper--login').hide();
      $('#recover-password').show();
    });

    $('.cancel-recover-password').on('click', function(){
      $('#recover-password').hide();
      $('.heading-wrapper--login').show();
      $('#login').show();
    })

  },

  unload: function($section) {
    $('.js-recover-password').off();
    $('.cancel-recover-password').off();
  }
}

/******/ })()
;